import { render, staticRenderFns } from "./StoreNeopag.vue?vue&type=template&id=dfae385e&"
import script from "./StoreNeopag.vue?vue&type=script&lang=js&"
export * from "./StoreNeopag.vue?vue&type=script&lang=js&"
import style0 from "./StoreNeopag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports